import WFNode from '../WFNode'
import WFRepeat from '../WFRepeat'
import * as WFC from '../WFConstants'

/**
 * Created by Xuz on 2020/03/25.
 * xuz@live.cn
 * 自循环
 * <p>
 * 越来越完善啦
 */
class TBRepeat {
  constructor (workflow) {
    this.workflow = workflow
    this.$_c = this.workflow.parent.$_c
  }

  doMouseDown (event) {
    let el = this.workflow.getSelectedElement(event)
    if (el == null) {
      this.workflow.setUnSelectLastElement(event)
    } else {
      this.workflow.setActiveElement(el, event)
      if (el instanceof WFNode) {
        if (el.getRepeater() != null) {
          this.workflow.setMessage('repeater.exist')
        } else {
          // 如果是起点或者终点，子流也不可以有循环，只有普通点加循环
          if (el.getType() !== WFC.NODE_TYPE_COMMON_NODE) {
            this.workflow.setMessage('repeater.only.commonnode')
            return
          }
          let repeater = new WFRepeat(this.workflow)
          repeater.create(event, el)
        }
      }
    }
  }

  /**
   * 鼠标移动时实现的接口
   */
  doMouseMove (event) {
  }

  /**
   * 鼠标松放时实现的接口
   */
  doMouseUp (event) {
  }

  /**
   * 双击时实现接口
   */
  doMouseDblClick (event) {
    const el = this.workflow.getSelectedElement(event)
    if (el == null) {
      this.workflow.setUnSelectLastElement(event)
    } else {
      if (el === this.workflow.getLastElement()) {
        el.onMouseDblClick(event)
      } else {
        this.workflow.setActiveElement(el, event)
      }
    }
  }

  getName () {
    return '自循环'
  }

  getIcon () {
    return this.$_c + 'app/workflow/img/design/repeat.png'
  }
}

export default TBRepeat
